import React from 'react';
import I18n from 'i18n-js';
import bind from '@reverbdotcom/commons/src/bind';
import { RCAlertBox } from '@reverbdotcom/commons/src/rc/RCAlertBox';
import { V3 } from './api_request';

interface IProps {
  paymentMethod: string;
  postURL: string;
  showAffirmWarning: boolean;
  checkoutUUID: string;
}

interface IState {
  code: string;
  error: string;
  disabled: boolean;
}

export default class PromoCodeRedemptionForm extends React.Component<IProps, IState> {
  state = {
    code: '',
    error: '',
    disabled: false,
  };

  @bind
  updateCode(evt) {
    this.setState({ code: evt.target.value });
  }

  @bind
  onSubmit(evt) {
    evt.preventDefault();
    this.setState({ disabled: true });

    return V3.postJSON(
      this.props.postURL,
      {
        discount_code: this.state.code,
        payment_method: this.props.paymentMethod,
        checkout_uuid: this.props.checkoutUUID,
      },
    ).then((res) => {
      if (res.redirect) {
        window.location = res.redirect;
      } else {
        this.handleError(res);
      }
    }).fail(this.handleError);
  }

  @bind
  handleError(res) {
    const error = res.message || I18n.t('discovery.promoCodeRedemptionForm.genericError');
    this.setState({
      error,
      disabled: false,
    });
  }

  submitValue(disabled) {
    if (disabled) {
      return I18n.t('discovery.wait');
    }

    return I18n.t('discovery.promoCodeRedemptionForm.submit');
  }

  render() {
    return (
      <div className="site-module">
        <div className="site-module__content">
          <h3 className="size-120 weight-bold mb-1">
            {I18n.t('discovery.promoCodeRedemptionForm.header')}
          </h3>
          {this.state.error &&
            <div className="mtb-2" data-promo-code-error>
              <RCAlertBox type="error">
                <p className="lh-120 mb-0">
                  {this.state.error}
                </p>
              </RCAlertBox>
            </div>
          }
          <form onSubmit={this.onSubmit}>
            <div className="g-container">
              <div className="g-col-9">
                <input
                  type="text"
                  name="discount_code"
                  id="discount_code"
                  placeholder={I18n.t('discovery.promoCodeRedemptionForm.placeholder')}
                  className="width-100"
                  value={this.state.code}
                  onChange={this.updateCode}
                />
              </div>
              <div className="g-col-3">
                <input
                  type="submit"
                  className="button button--primary width-100"
                  value={this.submitValue(this.state.disabled)}
                  disabled={this.state.disabled}
                />
              </div>
            </div>
            {this.props.showAffirmWarning &&
              <div className="mt-2" data-affirm-warning>
                <RCAlertBox type="warning" small>
                  <p className="mb-0 lh-120 icon-l-exclamation-triangle">
                    {I18n.t('discovery.promoCodeRedemptionForm.affirmWarning')}
                  </p>
                </RCAlertBox>
              </div>
            }
          </form>
        </div>
      </div>
    );
  }
}
